import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import ServiceDetail from '../../../components/public/services/ServiceDetail';
import { getServiceBySlug } from '../../../services/serviceService';
import Layout from '../../../components/public/common/Layout';
import TechLoader from '../../../components/common/TechLoader';

const ServiceDetailPage = () => {
  const { slug } = useParams();
  const [service, setService] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchService = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await getServiceBySlug(slug);
        if (data) {
          setService(data);
        } else {
          setError('Service not found');
        }
      } catch (err) {
        console.error('Error fetching service:', err);
        setError(err.message || 'Failed to load service');
      } finally {
        setLoading(false);
      }
    };

    fetchService();
  }, [slug]);

  if (loading) {
    return <TechLoader />;
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-4">Error</h1>
          <p className="text-gray-600">{error}</p>
        </div>
      </div>
    );
  }

  if (!service) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-4">Service Not Found</h1>
          <p className="text-gray-600">The service you're looking for doesn't exist.</p>
        </div>
      </div>
    );
  }

  return (
    <Layout>
      <Helmet>
        <title>{service.meta?.title || service.title} | Codeitronics</title>
        <meta name="description" content={service.meta?.description || ''} />
        <meta name="keywords" content={service.meta?.keywords?.join(', ') || ''} />
      </Helmet>
      <ServiceDetail service={service} />
    </Layout>
  );
};

export default ServiceDetailPage; 